import React from 'react';
import { Icon, Navbar, NavItem } from 'react-materialize';
import { BRAND_SUBTITLE, SITE_NAME, ZOOM_SCHEDULING_LINK } from '../../config/constants';
import logoImage from '../../img/mjr_logo_bell.png';
import './styles.scss';

export const HeaderComponent = () => {
  return (
    <div className='Header'>
      <Navbar
        id='main-nav'
        fixed
        alignLinks='right'
        menuIcon={<Icon>menu</Icon>}
        brand={
          <a href='/' className='brand-logo'>
            <img src={logoImage} alt={SITE_NAME} className="brand-logo-img" />
            <span className='brand-subtitle'>{BRAND_SUBTITLE}</span>
          </a>
        }
        style={{ backgroundColor: '#FFF' }}
      >
        <NavItem href='#about'>About</NavItem>
        <NavItem href='#services'>Services</NavItem>
        <NavItem href='#contact'>Contact</NavItem>
        <a href={ZOOM_SCHEDULING_LINK} target='_blank' rel='noopener noreferrer' className='book-session-btn nav-item'>Book a Session</a>
      </Navbar>
    </div>
  );
};
